export const truncate = (textChunk: string, maxChars: number) => {
    return (textChunk.length > maxChars) ? textChunk.slice(0, maxChars-1) + '\n...' : textChunk;
};

export default truncate;